import * as React from "react";
const SvgFiBrandsWikipedia = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      fillRule="evenodd"
      d="M24 4.656a.4.4 0 0 1-.08.236q-.081.106-.177.106-.79.075-1.292.509-.503.431-1.036 1.649l-5.446 12.272q-.053.171-.3.171a.34.34 0 0 1-.3-.171l-3.054-6.387-3.512 6.387a.34.34 0 0 1-.3.171q-.235 0-.31-.171L2.841 7.156q-.5-1.143-1.057-1.596T.236 4.998q-.087 0-.16-.091A.3.3 0 0 1 0 4.7q0-.3.171-.3.715 0 1.497.063.725.067 1.365.066.653 0 1.539-.065a25 25 0 0 1 1.644-.063q.171 0 .171.3 0 .298-.106.298c-.476.034-.852.157-1.126.36a.97.97 0 0 0-.412.814q0 .256.171.64L9.336 16.8l2.51-4.741-2.339-4.903q-.63-1.312-1.036-1.693-.405-.378-1.228-.464-.075 0-.144-.091a.33.33 0 0 1-.07-.207q0-.3.15-.3.715 0 1.313.063.576.067 1.228.066.64 0 1.355-.065a17 17 0 0 1 1.452-.063q.171 0 .171.3.001.298-.106.298-1.431.098-1.431.813 0 .32.331.992l1.547 3.141 1.539-2.873q.322-.61.322-1.028 0-.981-1.431-1.047-.13 0-.129-.298 0-.108.063-.203.066-.097.129-.097.513 0 1.26.063.716.066 1.176.065.331-.001.971-.055.811-.074 1.357-.074.127 0 .127.255 0 .342-.234.342-.834.085-1.34.46-.508.374-1.264 1.697l-2.052 3.793 2.778 5.659 4.101-9.537q.212-.523.213-.96 0-1.047-1.431-1.112-.13 0-.129-.298 0-.3.192-.3.523 0 1.239.063a12 12 0 0 0 1.11.065q.473 0 1.089-.065a12 12 0 0 1 1.155-.063q.15.003.15.258"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFiBrandsWikipedia;
